export const PROVIDER_META = {
  nuitee: { name: "Nuitee", color: "#6366f1" },
  holidu: { name: "Holidu", color: "#0284c7" },
  booking: { name: "Booking.com", color: "#003580" },
  direct: { name: "Direct", color: "#0f2d40" },
  flash: { name: "Flash Deal", color: "#c85a32" },
};

export function euro(n) {
  if (n === null || n === undefined) return "—";
  return "€" + Math.round(n);
}

export function providerName(id) {
  return PROVIDER_META[id]?.name ?? id;
}

export function countdown(endsAt) {
  const end = new Date(endsAt).getTime();
  const diff = Math.max(0, end - Date.now());
  const h = Math.floor(diff / 3.6e6);
  const m = Math.floor((diff % 3.6e6) / 6e4);
  const s = Math.floor((diff % 6e4) / 1000);
  const pad = (x) => String(x).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}


// Resize a Booking.com CDN image URL to a lighter variant for faster loading.
// variant examples: "square240" (thumbs), "max500" (cards), "max1024x768" (hero/lightbox).
export function bookingImg(url, variant = "max500") {
  if (!url || typeof url !== "string") return url;
  return url.replace(/\/(square|max)\d+x?\d*\//, `/${variant}/`);
}
